// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".section-default--contact__content{align-items:center;background-color:#fafafa;display:flex;flex-direction:column;justify-content:center;padding:60px 0 40px}.section-default--contact__form{max-width:540px;padding:0 20px;width:100%}.section-default--contact__leadtext{text-align:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
